<div class="mt-2">
  <div>
    <h5 class="text-center title-color">
      Primeiro Contato
    </h5>
  </div>
  <div class="p-mt-1">
    <apx-chart *ngIf="chartOptions" [series]="chartOptions.series" [chart]="chartOptions.chart" [plotOptions]="chartOptions.plotOptions"
      [dataLabels]="chartOptions.dataLabels" [xaxis]="chartOptions.xaxis" [tooltip]="chartOptions.tooltip">
    </apx-chart>
  </div>
</div>